import { withStyles } from '@material-ui/core/styles/withStyles';

export const GlobalStyle = {
  basicButton: {
    background: '#212121',
    color: '#fff',
    width: '100%',
    display: 'inline-block',
    textDecoration: 'none',
    textAlign: 'center',
    padding: '0.5em',
    borderRadius: '5em',
    marginTop: '0.4rem',
  },
  buttonGroup: {
    // position: 'absolute',
    // bottom: 0,
    // left: 0,
    marginTop: '2em',
    width: 'calc(100% - 2.175rem)',
    margin: '0px 1.0875rem 1.45rem',
    display: 'flex',
  },
  selectScroll: {
    display: 'flex',
    padding: '0.4rem 0',
  },
  selectStatic: {
    padding: '0.4rem 0',
  }
  // button: {
  //   background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  //   borderRadius: 3,
  //   border: 0,
  //   color: 'white',
  //   height: 48,
  //   padding: '0 30px',
  //   boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  // },
  // buttonBlue: {
  //   background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
  //   boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
  // },
};
